import * as React from "react"
import Svg, { G, Path } from "react-native-svg"

function GiftSwapIcon(props) {
  const { color, size, ...otherProps } = props;

  return (
    <Svg width={34} height={27} xmlns="http://www.w3.org/2000/svg" {...props}>
      <Path
        d="M33.644 8.95l-8.5-8.59a1.205 1.205 0 00-1.717 0c-.228.23-.355.542-.355.867V4.91h-8.5c-.671 0-1.215.55-1.215 1.227a1.22 1.22 0 001.214 1.228h9.715c.67 0 1.214-.55 1.214-1.228V4.19l5.569 5.628-5.569 5.628V13.5a1.22 1.22 0 00-1.214-1.227H10.928V8.59a1.22 1.22 0 00-1.214-1.227c-.322 0-.63.129-.858.359l-8.5 8.591a1.236 1.236 0 000 1.735l8.5 8.591a1.208 1.208 0 001.323.267c.454-.19.75-.638.75-1.134V22.09h8.5c.67 0 1.214-.55 1.214-1.227a1.22 1.22 0 00-1.214-1.228H9.714c-.67 0-1.214.55-1.214 1.228v1.946L2.93 17.182 8.5 11.553V13.5a1.22 1.22 0 001.214 1.227h13.358v3.682a1.22 1.22 0 001.214 1.227c.322 0 .63-.13.858-.36l8.5-8.59a1.237 1.237 0 000-1.736z"
        fill={color}
        fillRule="nonzero"
      />
    </Svg>
  )
}

export default GiftSwapIcon
